import React, { useEffect, useState } from "react";
import TinyMCEViewer from "../../TinyMCEViewer";
import FeedbackPopup from "./FeedbackPopupOld/FeedbackPopupOld";
import classes from './QuestionOld.module.css';
import QuestionOptions from "./QuestionOptionsOld/QuestionOptionsOld";
import QuestionText from "./QuestionTextOld/QuestionTextOld";

const quetionsViewerComponentEnum = {
    'options': QuestionOptions,
    'text': QuestionText
}

const QuestionOld = ({
    points,
    index,
    name,
    data,
    type,
    contentDirPath,
    id,
    completed,
    submission,
    statusObject,
    feedback,
    ansData,
    handleChangeAnsData,
    scoreByRetries,
    sendInProgress
}) => {

    const [correctText, setCorrectText] = useState()
    const Component = quetionsViewerComponentEnum[type];

    // todo change in new version
    useEffect(() => {
        if (data.options) {
            const correctText = data.options.filter(o => o.correct).map(o => o.content);
            setCorrectText(<TinyMCEViewer contentDirPath={contentDirPath} html={correctText.join(" ")}></TinyMCEViewer>)
        }
        if (data.correctAnswers) {
            setCorrectText(<div>{data.correctAnswers.map(ans => <div className={classes.CorrectAnsFeedback}>{ans} </div>)} </div>)
        }
    }, [data])

    return <div className={classes.Question}>
        <div className={classes.Name}>
            <div className={classes.NameInput}>
                <TinyMCEViewer html={name} contentDirPath={contentDirPath} />
            </div>
        </div>
        <Component
            points={points}
            handleChangeAnsData={handleChangeAnsData}
            {...data}
            id={id}
            sendInProgress={sendInProgress}
            completed={completed}
            submission={submission}
            statusObject={statusObject}
            index={index}
            feedback={feedback}
            ansData={ansData}
            contentDirPath={contentDirPath}
            scoreByRetries={scoreByRetries}
        />
        {feedback?.show && 
            <FeedbackPopup
                // close={cloaseFeedback}
                correctAnsText={correctText}
                type={feedback.type} />}
    </div>
}

export default QuestionOld;